// Dates affichées en français dans la conversation (checkup du 03/10) : les formateurs de
// lib/utils/timestamps.ts restent ceux de l'amont (anglais) ; les écrans de conversation passent
// par ces deux fonctions, mêmes règles, libellés et locale français.
import {
  format,
  formatDistance,
  isToday,
  isTomorrow,
  isValid,
  isYesterday,
  toDate,
} from "date-fns";
import { fr } from "date-fns/locale/fr";

const DATE_INVALIDE = "Date invalide";

// Même découpage que formatCalendarDate de l'amont : aujourd'hui, demain, hier, jour de la
// semaine sur sept jours, sinon jj/mm/aaaa.
export function formatCalendarDateFr(date: Date | number): string {
  const d = toDate(date);
  if (!isValid(d)) {
    return DATE_INVALIDE;
  }
  if (isToday(d)) {
    return "Aujourd'hui";
  }
  if (isTomorrow(d)) {
    return "Demain";
  }
  if (isYesterday(d)) {
    return "Hier";
  }
  const ecartJours = Math.floor(
    (Date.now() - d.getTime()) / (1000 * 60 * 60 * 24)
  );
  if (ecartJours > 0 && ecartJours <= 7) {
    return `${format(d, "EEEE", { locale: fr })} dernier`;
  }
  if (ecartJours < 0 && ecartJours >= -7) {
    return format(d, "EEEE", { locale: fr });
  }
  return format(d, "dd/MM/yyyy");
}

// « il y a 3 jours », « dans 2 heures ».
export function formatRelativeTimeFr(
  date: Date | number,
  maintenant: Date = new Date()
): string {
  const d = toDate(date);
  if (!isValid(d)) {
    return DATE_INVALIDE;
  }
  return formatDistance(d, maintenant, { addSuffix: true, locale: fr });
}
